module.exports = __webpack_public_path__ + "img/no-search-result.24956e58.png";